function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { Col, Button, Row, Label } from 'reactstrap';
import { kebabCase } from 'lodash';
import classnames from 'classnames';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { getURL } from '../../../actions/ajax';
import { getUser } from '../../common/classes/permissions';
import Icon from '../../common/containers/icon';
import ListPanel from '../../common/containers/listPanel';
import SinglePicker from '../../common/controls/singlePicker';
import MultiPicker from '../../common/controls/multiPicker';
import WhatsThis from '../../common/controls/whatsThis';
import entityComposition from '../../common/classes/entityComposition';
const handleDownload = () => {
  const element = global.document.getElementById('csvForm');
  if (element) {
    element.submit();
  }
};
const timezoneInfo = 'TRU stores all dates and times in UTC. Adjust this field to change the start and end times to your timezone of choice or leave the field blank to receive results in UTC.';
const buildFilters = (dataFilters, indexDefinitions = {}) => {
  const transformIndex = index => {
    const definition = indexDefinitions[index];
    if (!(definition !== null && definition !== void 0 && definition.referenceIndex)) {
      return {
        filterKey: 'name',
        index
      };
    }
    return {
      filterKey: 'id',
      index: definition.referenceIndex
    };
  };
  const indexes = Object.keys(dataFilters);
  const filters = indexes.map(filterIndex => {
    const {
      filterKey,
      index
    } = transformIndex(filterIndex);
    const filterValues = dataFilters[filterIndex];
    return filterValues.map(filter => encodeURIComponent(`${index}=${filter[filterKey]}`)).join('&filters=');
  });
  return filters;
};
const Summary = ({
  selectedSummary,
  jobs,
  summaryFilterOptions: _summaryFilterOptions = {},
  summaryFilterOptionsActions: {
    serverFilter: optionsServerFilter
  },
  notificationActions,
  settings
}) => {
  const {
    settings: {
      indexDefinitions = {}
    } = {}
  } = settings;

  // Build the list of Sundays from the nearest Sunday in the future
  // back to n weeks
  const weeksOfSundays = 210; // Lets go back just over 4 years
  const AllSundays = [];
  for (let i = -1; i < weeksOfSundays; i += 1) {
    AllSundays.push({
      id: moment().day(-7 * i).format('MM/DD/YYYY'),
      name: moment().day(-7 * i).format('MM/DD/YYYY')
    });
  }
  const timezones = momentTimezone.tz.names().map(name => ({
    id: name,
    name
  }));
  const currentTimezone = moment.tz.guess();
  const [weekEnding, setWeekEnding] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [sundays] = useState(AllSundays);
  const [timezone, setTimezone] = useState({
    name: currentTimezone,
    id: currentTimezone
  });
  const [timezonesState] = useState(timezones);
  const [summaryIdentifier, setSummaryIdentifier] = useState('');
  const [filterIndexes, setFilterIndexes] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  useEffect(() => {
    if (selectedSummary.query) {
      const regex = /CONTENT_INDEX\((.*?)\)/g;
      const matches = [...selectedSummary.query.matchAll(regex)];
      const extractedFilterIndexes = matches.map(match => match[1]);
      setFilterIndexes(extractedFilterIndexes);
    }
  }, [selectedSummary.query]);
  useEffect(() => {
    if (selectedSummary.identifier) {
      setSummaryIdentifier(selectedSummary.identifier);
    }
  }, [selectedSummary.identifier]);
  useEffect(() => {
    const fetchOptionsSequentially = async () => {
      if (summaryIdentifier && filterIndexes.length > 0) {
        for (let i = 0; i < filterIndexes.length; i += 1) {
          const filterIndex = filterIndexes[i];
          try {
            // eslint-disable-next-line no-await-in-loop
            await optionsServerFilter(summaryIdentifier, filterIndex);
          } catch (_unused) {
            throw new Error(`Failed fetching options for ${filterIndex}`);
          }
        }
      }
    };
    fetchOptionsSequentially();
  }, [optionsServerFilter, summaryIdentifier, filterIndexes]);
  const camelCaseToTitle = str => {
    const words = str.replace(/([A-Z])/g, ' $1');
    return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
  };
  const getSummaryUrl = () => {
    let url = `/summary/${summaryIdentifier}?`;

    // Attach the auth as a query parameter
    if (weekEnding) {
      url += `week_ending=${weekEnding.name}`;
    } else if (startDate && endDate) {
      let adjustedStart = startDate;
      let adjustedEnd = endDate;
      if (timezone) {
        // adjust the selected dates, which are in the browsers local timezone to the
        // selected timezone. Note that timezones west of UTC will have a negative
        // offset
        const currentTimeZone = moment.tz.guess();
        const currentTimezoneOffset = moment.tz(moment.utc(), currentTimeZone).utcOffset();
        const selectedTimezoneOffset = moment.tz(moment.utc(), timezone.name).utcOffset();
        adjustedStart = moment.utc(startDate).add(currentTimezoneOffset, 'minutes') // add the offset back to get to UTC
        .startOf('day') // set time to 00:00:00 UTC
        .subtract(selectedTimezoneOffset, 'minutes') // subtract the offset to get to tz
        .format(); // must use format, toISOString will return UTC
        adjustedEnd = moment.utc(endDate).add(currentTimezoneOffset, 'minutes').endOf('day') // set time to 23:59:59 UTC
        .subtract(selectedTimezoneOffset, 'minutes').format();
      }
      url += `start=${adjustedStart}&stop=${adjustedEnd}`;
      url += timezone ? `&timezone=${timezone.name}` : '';
    }
    if (selectedSummary.hasJob && selectedJobs) {
      const jobString = selectedJobs.map(job => job.id).join(',');
      url += `&jobs=${jobString}`;
    }
    if (Object.keys(selectedFilters).length > 0) {
      const dataToAppend = buildFilters(selectedFilters, indexDefinitions);
      url += `&filters=${dataToAppend.join('&filters=')}`;
    }
    return getURL(url);
  };
  const handleJobSelection = selection => {
    setSelectedJobs(selection);
  };
  const handleDownloadButton = () => {
    const {
      hasStart,
      hasStop
    } = selectedSummary;
    const needsDateValidation = hasStart && hasStop;
    if (needsDateValidation && moment(startDate).isAfter(endDate, 'date')) {
      return notificationActions.validationError({
        message: 'Your end date is before your start date!'
      });
    }
    handleDownload();
    return notificationActions.success({
      message: 'Your summary is downloading now...'
    });
  };

  /**
   *  Set the date received from dateTimePicker in state. dateTimePicker returns
   *  an ISO 8601 date adjusted for the current browser's timezone
   */
  const handleDateChange = (datePickerName, updatedDate) => {
    const dateSetters = {
      weekEnding: setWeekEnding,
      startDate: setStartDate,
      endDate: setEndDate,
      timezone: setTimezone
    };
    const setDateState = dateSetters[datePickerName];
    if (setDateState) {
      setDateState(updatedDate);
    }
  };
  const handleFilterSelection = filterIndex => selection => {
    setSelectedFilters(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [filterIndex]: selection
    }));
  };
  const {
    hasWeekEnding,
    hasStart,
    hasStop
  } = selectedSummary;
  const downloadEnabled = startDate && endDate || hasStart && !hasStop && startDate || hasStop && !hasStart && endDate || hasWeekEnding && weekEnding || !hasWeekEnding && !hasStart && !hasStop;

  // d-none is the bootstrap classname for display: none
  const weekEndingClasses = classnames({
    'd-none': !hasWeekEnding,
    weekEnding: true
  });
  const timeRangeClasses = classnames({
    'd-none': !hasStart && !hasStop,
    timeRange: true
  });
  const jobPickerClasses = classnames({
    'd-none': !selectedSummary.hasJob,
    jobPicker: true
  });
  const timeStartClasses = classnames({
    'd-none': !hasStart,
    timeStart: !hasStart,
    timeRange: true
  });
  const timeStopClasses = classnames({
    'd-none': !hasStop,
    timeStop: !hasStop,
    timeRange: true
  });
  return /*#__PURE__*/React.createElement(ListPanel, {
    title: selectedSummary.name,
    showNew: false
  }, selectedSummary.name !== selectedSummary.note ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: `t-s-${kebabCase(selectedSummary.note)}`
  }, selectedSummary.note), /*#__PURE__*/React.createElement("hr", null)) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12,
    className: jobPickerClasses
  }, /*#__PURE__*/React.createElement(Label, null, "Jobs (Optional)"), /*#__PURE__*/React.createElement(MultiPicker, {
    className: "t-s-job-picker",
    labelKey: "jobNumber",
    valueKey: "id",
    options: jobs,
    values: selectedJobs,
    placeholder: "Select Job...",
    onChange: handleJobSelection
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: weekEndingClasses
  }, /*#__PURE__*/React.createElement(Label, null, "Week Ending"), /*#__PURE__*/React.createElement(SinglePicker, {
    className: "t-s-week-ending",
    name: "weekEnding",
    options: sundays,
    value: weekEnding,
    placeholder: "Select Sunday...",
    onChange: value => handleDateChange('weekEnding', value)
  })), /*#__PURE__*/React.createElement(Row, {
    style: {
      width: '100%',
      marginRight: '0',
      marginLeft: '0'
    }
  }, filterIndexes.length > 0 && filterIndexes.map(filterIndex => {
    var _summaryFilterOptions2, _summaryFilterOptions3;
    // Check if the list exists and has items
    const hasListData = ((_summaryFilterOptions2 = _summaryFilterOptions[summaryIdentifier]) === null || _summaryFilterOptions2 === void 0 || (_summaryFilterOptions2 = _summaryFilterOptions2[filterIndex]) === null || _summaryFilterOptions2 === void 0 || (_summaryFilterOptions2 = _summaryFilterOptions2.list) === null || _summaryFilterOptions2 === void 0 ? void 0 : _summaryFilterOptions2.length) > 0;

    // Only render the picker if there is data
    return hasListData && /*#__PURE__*/React.createElement(Col, {
      sm: 6,
      key: filterIndex
    }, /*#__PURE__*/React.createElement(Label, null, camelCaseToTitle(filterIndex)), /*#__PURE__*/React.createElement(MultiPicker, {
      className: "t-s-filter-picker",
      labelKey: "name",
      valueKey: "id",
      options: ((_summaryFilterOptions3 = _summaryFilterOptions[summaryIdentifier]) === null || _summaryFilterOptions3 === void 0 || (_summaryFilterOptions3 = _summaryFilterOptions3[filterIndex]) === null || _summaryFilterOptions3 === void 0 ? void 0 : _summaryFilterOptions3.list) || [],
      values: selectedFilters[filterIndex] || [],
      placeholder: "Select filter...",
      onChange: handleFilterSelection(filterIndex)
    }));
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: timeStartClasses
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    label: "Start",
    dateFormat: "MM/DD/YYYY",
    defaultValue: startDate,
    onChange: value => handleDateChange('startDate', value)
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: timeStopClasses
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    label: "End",
    dateFormat: "MM/DD/YYYY",
    defaultValue: endDate,
    onChange: value => handleDateChange('endDate', value)
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: timeRangeClasses
  }, /*#__PURE__*/React.createElement(Label, null, "Timezone\xA0", /*#__PURE__*/React.createElement(WhatsThis, {
    text: timezoneInfo
  })), /*#__PURE__*/React.createElement(SinglePicker, {
    className: "t-s-timezone",
    name: "timezone",
    options: timezonesState,
    value: timezone,
    onChange: value => handleDateChange('timezone', value)
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3,
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "t-s-button-download",
    size: "sm",
    label: "Download",
    onClick: handleDownloadButton,
    disabled: !downloadEnabled,
    className: "float-md-right pull-down form-control t-s-download tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "download"
  }), " Download"))), /*#__PURE__*/React.createElement("iframe", {
    title: "csvContainer",
    src: "",
    name: "csvContainer",
    style: {
      width: 0,
      height: 0,
      border: 'none'
    }
  }), downloadEnabled ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    id: "csvForm",
    target: "csvContainer",
    action: getSummaryUrl(),
    method: "post"
  }, /*#__PURE__*/React.createElement("input", {
    className: "t-s-token",
    type: "hidden",
    name: "access_token",
    value: getUser().access_token
  }))) : null);
};
Summary.propTypes = {
  settings: PropTypes.shape({
    settings: PropTypes.shape({
      indexDefinitions: PropTypes.shape({})
    })
  }).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedSummary: PropTypes.shape({
    query: PropTypes.string,
    hasStart: PropTypes.number,
    hasStop: PropTypes.number,
    name: PropTypes.string,
    note: PropTypes.string,
    identifier: PropTypes.string,
    hasWeekEnding: PropTypes.number,
    hasJob: PropTypes.number
  }).isRequired,
  notificationActions: PropTypes.shape({
    success: PropTypes.func,
    validationError: PropTypes.func
  }).isRequired,
  summaryFilterOptions: PropTypes.shape({
    currentSummary: PropTypes.string,
    currentFilter: PropTypes.string
  }),
  summaryFilterOptionsActions: PropTypes.shape({
    serverFilter: PropTypes.func
    // pageNext: PropTypes.func,
  }).isRequired
};
export { Summary as TestSummary };
export default entityComposition(Summary, ['summary', 'summaryFilterOptions', 'settings'], {}, ['notification']);